import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';

import AppLayout from './layouts/AppLayout';

function App() {
  return (
    <Suspense fallback={`...loading`}>
      <AppLayout>
          <ToastContainer autoClose={2000} draggable={false} transition={Slide} hideProgressBar />
          <Outlet />
      </AppLayout>
    </Suspense>
  );
}

export default App;
